export default __webpack_public_path__ + "static/media/lemontbotanique_s3.714bf3a9.png";